<template>
    <div>
        <div class="row" v-if="evaluation">

            <div class="col-11">
                <evaluation-items
                    :session="session"
                    :grid="grid"
                    :competencies="competencies"
                    :evaluation="evaluation"
                    :lang="session.degree.lang"
                    :features="features"
                    :stats="stats"
                    @evaluationChanged="$emit('reload-session')"
                ></evaluation-items>
    
                <div class="text-center fixed-bottom mt-1" :class="{ showButtons: showButtons }">
                    <base-button type="primary" @click.prevent="features.openObservation()">
                        <i class="fas fa-chevron-left mr-1"></i> {{ $t('sessions.observation') }}
                    </base-button>

                    <base-button type="primary" @click.prevent="features.openSummary()">
                        {{ $t('sessions.summary') }} <i class="fas fa-chevron-right ml-1"></i>
                    </base-button>
                </div>

            </div>
            <div class="col-1">
                <features
                    :session="session"
                    :stats="stats"
                    :features="features"
                    @reload-stats="$emit('reload-stats')"
                ></features>
            </div>
        </div>
        <back-to-top></back-to-top>
    </div>
</template>

<script>
    import SessionFeatures from './SessionFeatures'
    import EvaluationItems from './evaluation/EvaluationItems'
    import Features from './evaluation/GlobalFeatures'

    export default {

        components: {
            EvaluationItems, Features
        },

        props: {

            session: {
                type: Object,
                required: true
            },

            grid: {
                type: Object,
                required: true
            },

            competencies: {
                type: Object,
                default: null
            },
                        
            stats: {
                type: Object,
                default: null
            },

            evaluation: {
                type: Object,
                default: null
            },
        },

        data() {
            return {
                features: new SessionFeatures(this.$router, this.$auth, this.session),
                showButtons: false,
            }
        },

        mounted() {
            $(window).scroll(() => {
                this.showButtons = $(window).scrollTop() > 300
            });
        },
    }
</script>

<style lang="css" scoped>

    .fixed-bottom {
        position: sticky;
        bottom: 30px;
        z-index: 1000;
        opacity: 0;
        visibility: hidden;
        transition:
        opacity .5s,
        visibility .5s;
    }
    .showButtons {
        opacity: 1;
        visibility: visible;
    }

</style>
